import {ActionsService} from '../../Redux/Actions/actions.service';
import {ApplicationProjectTypeActions} from '../../Redux/Actions/application-project-types-actions';
import {Component, OnInit} from '@angular/core';
import {select} from '@angular-redux/store';
import {Router, Event, NavigationEnd} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {isNullOrUndefined} from 'util';
import {animate, state, style, transition, trigger} from "@angular/animations";
import {edsEnvConfiguration} from "../../../environments/edsEnvConfiguration";
import {Observable} from "rxjs";
import {ApplicationToolbarActions} from "../../Redux/Actions/application-toolbar-actions";
import {AnalyticsActions} from "../../Redux/Actions/analytics.actions";
import {IProjectTypeSelector} from "../../models/common";

type MenuItem = IProjectTypeSelector & {runnable?: boolean, create?: boolean};

@Component({
  selector: "edsng-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: [
    "./sidebar.component.css",
    "./sidebar.component.mobile.css",
    "./sidebar.component.tablet.css"
  ],
  animations: [
    trigger('fadeOut', [
      state('visible', style({opacity: 1})),
      state('invisible', style({opacity: 0})),
      transition('* => visible', [animate('0.2s')]),
      transition('* => invisible', [animate('0.2s')]),
      transition('stateNormal => *', [animate('0.2s')]),
      transition('* => stateNormal', [animate('0.2s')]),
      transition('stateUp => stateDown', [animate('0s')]),
      transition('stateDown => stateUp', [animate('0s')]),
      state('stateNormal', style({transform: 'translateY(0px)', opacity: 1})),
      state('stateUp', style({transform: 'translateY(-1.5em)', opacity: 0.1})),
      state('stateDown', style({transform: 'translateY(1.5em)', opacity: 0.1})),
    ])
  ]
})
export class SidebarComponent implements OnInit {

  @select(["appToolBar", "sideBarOpened"]) sideBarOpened$: Observable<boolean>;
  @select(["appProjectTypes", "rootMenu"]) rootMenu$: Observable<MenuItem[]>;

  private _directionAnimation = 0;
  private childSelected = null;
  animationState = 'stateNormal';
  animationChild = 'visible';

  sidebarOpened: boolean = false;

  // this array maintain a array of the user navigation
  menuNavigationChain: MenuItem[] = [];

  // navigation steps
  get menuNavigationSteps(): number {
    return this.menuNavigationChain.length;
  }

  get currentMenu(): MenuItem {
    return this.menuNavigationChain[this.menuNavigationSteps - 1];
  }

  get parentMenu(): IProjectTypeSelector {
    return this.menuNavigationChain[this.menuNavigationSteps - 2];
  }

  constructor(private router: Router, public snack: MatSnackBar, private act: ActionsService ) {
  }

  set directionAnimation(v: number) {
    this._directionAnimation = v;
    this.animationState = v > 0 ? 'stateUp' : 'stateDown';
    this.animationChild = 'invisible';
  }

  animationTransitionDone() {
    if (this.animationState === 'stateNormal') {
      this._directionAnimation = 0;
      this.animationChild = 'visible';
    }

    this.animationState = (this._directionAnimation > 0) ?
      (this.animationState === 'stateUp' ? 'stateDown' : 'stateNormal') :
      (this.animationState === 'stateDown' ? 'stateUp' : 'stateNormal');

    if ((this._directionAnimation > 0 && (this.animationState === 'stateDown')) ||
      (this._directionAnimation < 0 && (this.animationState === 'stateUp'))) {

      if (this._directionAnimation < 0) {
        this.previousTree();
      }

      if (this._directionAnimation > 0) {
        this.clickChild(this.childSelected);
        this.childSelected = null;
      }
    }
  }

  ngOnInit() {
    this.act.sendAction(ApplicationProjectTypeActions.loadProjectTypes());

    this.sideBarOpened$.subscribe((x) => {
      this.sidebarOpened = x;
    });

    // this.router.events.subscribe((event: Event) => {
    //   if (event instanceof NavigationEnd && (event.url === '/home' || event.url === '/')) {
    //     this.act.sendAction(ApplicationToolbarActions.setSideBarOpened(true));
    //   }
    // });
  }

  manageSidebar() {
    this.act.sendAction(ApplicationToolbarActions.switchSideBar());
  }

  getChildIcon(child): string {
    if (this.hasSubNode(child)) {
      return "keyboard_arrow_right";
    }

    if (this.canBeOpened(child)) {
      if (child.url === undefined) {
        return "play_circle_outline";
      } else {
        return "open_in_new";
      }
    }

    return "keyboard_arrow_right";
  }

  private hasSubNode(child) {
    return child && child.nodes && child.nodes.length > 0;
  }

  private canBeOpened(child) {
    return child !== null && (child.start === true || child.create === true || child.go === true || child.download === true);
  }

  clickChild(child) {
    if (this.canBeOpened(child)) {
      this.startSelector(child);
    } else if (this.hasSubNode(child)) {
      this.menuGoChild(child);
    }
  }

  menuChildRun(child) {
    if (this.canBeOpened(child)) {
      this.clickChild(child);
    } else {
      this.directionAnimation = 1;
      this.childSelected = child;
    }
  }


  /**
   * funzione utilizzata per andare avanti tra la gerarchia dei nodi
   * @param item item selezionato
   */
  menuGoChild(item) {
    if (this.hasSubNode(item)) {
      if (this.hasSubNode(item)) {
        this.menuNavigationChain.push(item);
      }
    } else {
      if (!item.url) {
        this.startSelector(item);
      }
    }
  }

  menuGoParent() {
      this.directionAnimation = -1;
  }

  previousTree() {
    this.menuNavigationChain.pop();
  }

  /**
   * Funzione per lo start Selector
   * @param item selezionato
   */
  startSelector(item) {
    if (isNullOrUndefined(item.url) && !isNullOrUndefined(item.catalog) && !isNullOrUndefined(item.classType)) {

      this.router.navigate([
        "/app",
        item.classType,
        item.catalog,
        "filter",
        this.paramToString(item.filterTopologies)
      ]);

      /**
       * Gestita la sidebar
       */
      this.manageSidebar();

    } else if (!isNullOrUndefined(item.url)) {
      const uri = (item.url as string).trim().toLowerCase();
      const url = (uri.startsWith("http") || uri.startsWith("/"))
        ? item.url
        : (edsEnvConfiguration.edsUrl + item.url);
      this.act.sendAction(AnalyticsActions.sendAnalyticsEvent("open_application", "redirect", {details: url, tag: "sidebar", module: "home"}));
      window.open(url, "_blank");
    } else {
      this.snack.open("Invalid menu entry for " + item.name, "OK", {
        duration: 3000
      });
    }
  }

  private paramToString(obj: any): string {
    return isNullOrUndefined(obj) ? "[]" : JSON.stringify(obj);
  }


}
